{
  "GOOGLE": "Log ind med Google",
  "FACEBOOK": "Log ind med Facebook",
  "LINKEDIN": "Log ind med LinkedIn",
  "google": "Fortsæt med Google",
  "FACEBOOK_LOGIN": "Fortsæt med Facebook",
  "LINKEDIN_LOGIN": "Fortsæt med LinkedIn",
  "Email": "Fortsæt med Email",
  "COMPLETED": "Fuldført",
  "DECLINED": "Afvist",
  "EXPIRED": "Udløbet",
  "IN_PROGRESS": "I gang",
  "SIGNED": "Underskrevet",
  "REJECTED": "Afvist",
  "DONE": "Færdig",
  "CANCELLED": "Annulleret",
  "COPIED": "Tekst kopieret",
  "FAILED_TO_COPIED": "Kunne ikke kopiere tekst",
  "DISCARD": "Kassér",
  "BRANDING": "Branding",
  "SOON": "Snart",
  "PREVIEW": "Preview",
  "TITLE": "Titel",
  "FULL_NAME": "Fuldt navn",
  "PHONE": "Telefonnummer",
  "PREFERRED_LANGUAGE": "Systemsprog",
  "SEARCH": "Søg",
  "SELECT": "Vælg",
  "UPGRADE": "Opgrader",
  "CONTACT_US": "Kontakt os",
  "SIGNATURES": "Underskrifter",
  "PHONE_NUMBER": "Telefonnummer",
  "COUNTRY_CODE": "Landekode",
  "SELECTED": "Valgt",
  "UPDATE": "Gem ændringer",
  "ACTIVE": "Aktiv",
  "PENDING": "Afventer",
  "MONTH": "Måned",
  "YEAR": "År",
  "OPEN_DROPDOWN_MENU": "Åbn rullemenu",
  "UNDO_CHANGES": "Fortryd ændringer",
  "DISMISS": "Afvis",
  "DATE": "Dato",
  "DESCRIPTION": "Beskrivelse",
  "ENGLISH": "Engelsk",
  "ARABIC": "Arabisk",
  "FRENCH": "Fransk",
  "DANISH": "Dansk",
  "GENERAL": {
    "SERVICE_IN_MAINTENANCE": "Tjenesten er under vedligeholdelse",
    "CANCEL": "Annuller",
    "EMAIL_ADDRESS": "E-mailadresse",
    "EMAIL": "Email",
    "VOILA": "Voilà",
    "NO_CANCEL": "Nej, annuller",
    "YES_DELETE": "Ja, slet",
    "CONFIRM": "Ja, jeg er sikker",
    "CONTINUE": "Fortsætte",
    "BACK": "Tilbage",
    "ERROR_MESSAGES": {
      "SOMETHING_WENT_WRONG": "Noget gik galt. Prøv venligst igen senere!",
      "NOT_FOUND": "Ups!!! Siden blev ikke fundet!",
      "SERVER_ERROR": "Intern serverfejl",
      "UNAUTHORIZED": "Uautoriseret"
    }
  },
  "LANGUAGES": {
    "ENGLISH": "Engelsk",
    "DANISH": "Dansk",
    "ARABIC": "Arabisk",
    "FRENCH": "Fransk"
  },
  "ORDER_STATUS_ICON": "ordrestatusikon",
  "ORDER_ACTION_MENU": "Bestil handling menu",
  "ORDER-STATISTICS": {
    "ALL-ORDER": "Alle ordrer",
    "ACTIVE-ORDERS": "I gang",
    "COMPLETED-ORDERS": "Fuldførte",
    "CLOSED-ORDERS": "Lukkede"
  },
  "ORDER-DETAILS": {
    "ORDER-CANCELLED": {
      "SUCCESS": "Ordre annulleret",
      "ERROR": "Kunne ikke annullere ordre"
    },
    "ORDER-TITLE": "Ordretitel",
    "RECIPIENTS": "Modtagere",
    "STATUS": "Status",
    "SIGNING_STATUS": "Signeringsstatus",
    "LAST-CHANGE": "Aktivitet",
    "EXPIRING-DATE": "Udløbsdato",
    "ACTIONS": "Handlinger",
    "ORDER-OPTIONS": {
      "SEND-REMINDER": "Send påmindelse",
      "ORDER-ACTIVITY": "Ordre aktivitet",
      "ORDER-DETAILS": "Ordredetaljer",
      "CANCEL-ORDER": "Annuller ordre"
    },
    "CANCEL-ORDER-MODAL": {
      "TITLE": "Annuller denne underskriftsordre?",
      "SUBTITLE": "Dette giver alle modtagere besked.",
      "DESCRIPTION": "Alle modtagere vil blive underrettet og kan ikke længere underskrive. Denne handling kan ikke fortrydes.",
      "CALLOUT": "Når dokumentet er annulleret, kan det ikke genaktiveres.",
      "KEEP-ORDER": "Nej, behold ordre",
      "CANCEL-ORDER": "Annuller ordre"
    },
    "ORDER": "Ordre",
    "TO": "Til",
    "BY": "Af",
    "AT": "kl.",
    "MORE": "mere",
    "DONE": "færdig",
    "ORDER-STATUS": "Ordrestatus",
    "SENT": "Sendt",
    "EXPIRES": "Udløber",
    "SIGNED-BY": "Underskrevet af",
    "OF": "af",
    "SIGNERS": "Underskrivere",
    "ORDER-ID": "Ordre-ID",
    "DAYS-REMAINING": "dage tilbage",
    "COMPLETION": "Færdiggørelse",
    "ATTACHMENTS": "Vedhæftede filer",
    "UPLOADED-BY": "Uploadet af",
    "SIGNED-ON": "Underskrevet den",
    "REJECTED-ON": "Afvist den",
    "AUDIT-MOCK": "IP: — · OS: — · Browser: —",
    "ACTIVITY-LOG": "Aktivitetslog",
    "RECEIVERS": "Modtagere",
    "REVIEWED-BY": "Gennemgået af",
    "REVIEWERS": "Gennemgangspersoner",
    "DOCUMENTS": "dokumenter",
    "NO-SIGNERS": "Ingen underskrivere",
    "NO-RECEIVERS": "Ingen modtagere",
    "NO-REVIEWERS": "Ingen gennemgangspersoner",
    "REMINDER-SENT": "Påmindelse sendt",
    "RESEND-REMINDER": "Gensend påmindelse",
    "CREATED-BY": "Oprettet af"
  },
  "PAGINATION": {
    "PREVIOUS": "Forrige",
    "NEXT": "Næste",
    "PER_PAGE": "Pr. side",
    "SHOWING_RESULTS": "Viser {{from}}-{{to}} af {{totalLength}} resultater"
  },
  "LANG": "Dansk",
  "PROCESSING": "behandler...",
  "SAVE": "Gem",
  "SAVE_DISCOUNT": "Spare",
  "SEND_ORDER": "Send ordre",
  "DAY": "dag",
  "DAYS": "dage",
  "REVIEWER": "Skal gennemgå",
  "SIGNER": "Skal underskrive",
  "COPIER": "Modtag en kopi",
  "SIDE_BAR": {
    "SIGNING": "Underskrift ordrer",
    "SETTINGS": "Indstillinger",
    "FAQ": "Ofte stillede spørgsmål",
    "FORMS": "Formularer",
    "LOG_OUT": "Log ud",
    "PROFILE": "Profil"
  },
  "HEADER": {
    "CREATE_ORDER": "Opret ordre",
    "MANAGE_ORDER": "Underskriftsordrer"
  },
  "CONTRACT_ORDER": {
    "RECIPIENT_INFORMATION": "Modtager information",
    "ORDER_SETTINGS": "Ordre indstillinger",
    "ORDER_MESSAGE": "Ordre besked",
    "NEW_SIGNING_ORDER": "Ny underskriftsordre",
    "ORDER_TITLE": "Ordretitel",
    "REMIND_SIGNERS": "Mind underskrivere hver",
    "EMAIL_SUBJECT": "E-mail-emne",
    "EMAIL_SUBJECT_PLACEHOLDER": "[Afsendernavn] har sendt dig dokumenter til underskrivelse",
    "EMAIL_BODY": "Besked",
    "EMAIL_BODY_PLACEHOLDER": "Tilføj en kort besked til dine modtagere (valgfrit). Den vises i e-mailen sammen med linket til underskrivelse.",
    "NAME": "Navn",
    "EMAIL": "Email",
    "PHONE_NUMBER": "Telefonnummer",
    "TASK": "Opgave",
    "ADD_RECIPIENT": "Tilføj modtager",
    "ACTIONS": "Handlinger",
    "PRIORITY": "Prioritet",
    "MESSAGE-ALL": "Besked til alle",
    "SELECT-TASK": "Vælg en opgave",
    "SELECT-PRIORITY": "Vælg en prioritet",
    "ENTER-EMAIL": "Indtast email adresse",
    "ENTER-NAME": "Indtast dit navn",
    "ENTER-PHONE": "Indtast telefonnummer",
    "MOVE_DOWN": "Flyt ned",
    "MOVE_UP": "Flyt op",
    "DELETE": "Slet",
    "RECEIVE": "Modtag",
    "ROLE": "Rolle",
    "REVIEW_DOCUMENT": "Gennemgå dokument",
    "SIGN_DOCUMENT": "Underskriv dokument",
    "MOVE_TO": "Flyt til",
    "NO_RECIPIENTS": "Ingen modtagere tilføjet endnu",
    "RECEIVE_NEXT": "Modtag næste",
    "REMIND_PERIOD": "Mind modtager hver",
    "EXPIRATION_PERIOD": "Udløbsperiode",
    "LOGIN_TO_VIEW_DOCUMENTS": "Login kræves for at se dokumenter",
    "RECEIVE_COPY": "Modtag en kopi",
    "NEXT": "Næste",
    "SEND_ORDER": "Send ordre",
    "SIGNING_METHOD": "Underskriftmetode (valgfri)",
    "REMINDERS_SENT_SUCCESSFULLY": "Påmindelser er sendt",
    "ORDER_WAS_CANCELLED_OR_DECLINED": "Ordren blev annulleret eller afvist!",
    "OUT_OF_SIGNATURES_WARNING": "Ingen signaturer tilbage.",
    "EXTRA_SIGNATURES_ARE_NEEDED": "Denne ordre kan muligvis ikke gennemføres på grund af manglende underskrifter.",
    "CANT_ADD_RECIPIENTS": "Du kan ikke tilføje flere modtagere på grund af manglende signaturer.",
    "VERIFICATION_METHOD": "Verifikationsmetode",
    "WHATSAPP": "Whatsapp",
    "DISCARD_ORDER_TITLE": "Bekræft annullering af ordre",
    "DISCARD_ORDER_SUBTITLE": "Denne handling kan ikke fortrydes.",
    "DISCARD_ORDER_DESCRIPTION": "Er du sikker på, at du vil annullere denne ordre?",
    "KEEP_EDITING": "Fortsæt med at redigere",
    "DISCARD_ORDER": "Annuller ordre",
    "NOT_SPECIFIED": "Ikke defineret",
    "NEW_SIGNING_ORDER_SUBTITLE": "Tilføj dine dokumenter, vælg hvem der skal underskrive og i hvilken rækkefølge, og send derefter.",
    "ORDER_LANGUAGE": "Ordresprog",
    "RECIPIENT_DETAILS": "Modtageroplysninger",
    "RECEIVER_DETAILS": "Modtageroplysninger",
    "NO_RECEIVERS_YET": "Ingen modtager tilføjet endnu",
    "ADD_RECEIVER": "Tilføj modtager",
    "RECIPIENTS_LABEL": "modtagere",
    "RECEIVERS_LABEL": "modtagere",
    "ORDINAL_RECIPIENTS": [
      "Første modtager/modtagere",
      "Anden modtager/modtagere",
      "Tredje modtager/modtagere",
      "Fjerde modtager/modtagere",
      "Femte modtager/modtagere",
      "Sjette modtager/modtagere",
      "Syvende modtager/modtagere",
      "Ottende modtager/modtagere",
      "Niende modtager/modtagere",
      "Tiende modtager/modtagere"
    ]
  },
  "SETTINGS": {
    "NAME": "Indstillinger",
    "ACCOUNT_INFO": "Kontooplysninger",
    "CHANGE_PASSWORD": "Skift adgangskode",
    "CHANGE_PASSWORD_EMAIL_SENT": "E-mail til nulstilling af adgangskode er sendt til din indbakke",
    "CHANGE_PASSWORD_EMAIL_FAILED": "Det lykkedes ikke at sende e-mail til nulstilling af adgangskode, prøv venligst igen",
    "TEAM_MANAGEMENT": "Brugerstyring",
    "TEAM_MANAGEMENT_DESCRIPTION": "Administrer teammedlemmer og deres adgangsrettigheder.",
    "ORDER_SETTINGS": "Ordreindstillinger",
    "FIRST_NAME": "Fornavn",
    "LAST_NAME": "Efternavn",
    "ROLE": "Rolle",
    "INVITATION_STATUS": "Invitationsstatus",
    "INVITE_SUCCESS": "Bruger inviteret",
    "INVITE_ERROR": "Fejl ved invitation af bruger",
    "INVITE_MEMBERS_ERROR": "Kunne ikke sende invitationer. Prøv igen fra Indstillinger.",
    "SEND_INVITATION": "Send invitation",
    "MANAGE_SUBSCRIPTION": "Abonnementsstyring",
    "SUBSCRIPTIONS": "Abonnementer",
    "CHANGE_PLAN": "Rediger abonnementsplan",
    "MANAGE_PAYMENTS": "Administrer betalinger",
    "CHANGE_PLAN_QUESTION": "Skift abonnement",
    "CANCEL_SUBSCRIPTION": "Annuller abonnement",
    "DELETE_TEAM_MEMBER": "Slet bruger",
    "DELETE_TEAM_MEMBER_DESCRIPTION": "Du er ved at fjerne \"<span class='font-bold'>{{name}}</span>\" fra holdet. Deres <span class='font-bold'>{{ordersCount}}</span> aktive ordrer vil blive tildelt et andet medlem.",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_NAME": "Du er ved at fjerne \"<span class='font-bold'>{{email}}</span>\" fra holdet. Deres <span class='font-bold'>{{ordersCount}}</span> aktive ordrer vil blive tildelt et andet medlem.",
    "PLAN_NAME": "<span class='font-bold'>Abonnement:</span> <span class='font-medium'>{{planName}}</span>",
    "SUBSCRIPTION_MANAGEMENT": "Abonnement",
    "SUBSCRIPTION_MANAGEMENT_DESCRIPTION": "Overvåg dit forbrug og administrer dine abonnementsplandetaljer.",
    "TRANSACTION_HISTORY": "Faktureringshistorik",
    "SIGNATURES_USED_OF": "af {{signatures}} anvendte underskrifter",
    "SIGNATURES_USED_TOTAL": "{{used}} af {{total}} brugt",
    "SIGNATURE_USAGE": "Signaturforbrug",
    "AUTO_RENEWAL": "Automatisk fornyelse",
    "SUBSCRIPTIONS_TITLE": "Tilføj flere underskrifter",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_ORDER": "Du er ved at fjerne \"<span class='font-bold'>{{name}}</span>\" fra holdet.",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_ORDER_NO_NAME": "Du er ved at fjerne \"<span class='font-bold'>{{email}}</span>\" fra holdet.",
    "REASSIGN_BEFORE_REMOVING": "Overdrag deres arbejde inden fjernelse.",
    "REASSIGN_ORDERS_TO": "Tildel ordrer til",
    "INVITE_TEAM_MEMBER": "Tilføj teammedlem",
    "INVITE_TEAM_MEMBER_TITLE": "Inviter teammedlem",
    "INVITE_TEAM_MEMBER_SUBTITLE": "Tilføj et nyt medlem til dit arbejdsområde.",
    "MEMBER_INVITATION_NOTE": "Hvert medlem modtager en invitationsmail for at oprette sin konto.",
    "ACCEPT_TERMS_AND_CONDITIONS": "Jeg accepterer vilkårene og privatlivspolitikken",
    "USER_DELETED_SUCCESSFULLY": "Brugeren blev slettet succesfuldt",
    "FAILED_TO_DELETE_USER": "Kunne ikke slette brugeren",
    "ACCOUNT_SETTINGS_UPDATED_SUCCESSFULLY": "Kontoindstillinger blev opdateret succesfuldt",
    "FAILED_TO_UPDATE_ACCOUNT_SETTINGS": "Kunne ikke opdatere kontoindstillinger",
    "PUBLIC_PROFILE": "Konto",
    "PUBLIC_PROFILE_SUBTITLE": "Dine personlige oplysninger, dit sprog og din adgangskode.",
    "PROFILE_PICTURE": "Profilbillede",
    "UPLOAD_NEW_PHOTO": "Upload nyt foto",
    "PHOTO_HINT": "JPG eller PNG. Maks. størrelse {{maxSizeMb}}MB",
    "PREFERENCES": "Præferencer",
    "PREFERENCES_SUBTITLE": "Vælg det sprog, JunoSign vises på.",
    "ACCOUNT_SECURITY": "Kontosikkerhed",
    "ACCOUNT_SECURITY_SUBTITLE": "Administrer din adgangskode og godkendelsesindstillinger.",
    "CHOOSE_A_PLAN": "Opgrader dit abonnement til at matche dit forretningsbehov",
    "CHOOSE_A_PLAN_DESCRIPTION": "Her hos JunoSign fokuserer vi på markeder, hvor teknologi, innovation og kapital kan frigøre langsigtet værdi og drive økonomisk vækst.",
    "PER_USER_MONTHLY": "Pr. bruger/måned",
    "PER_USER_YEARLY": "Pr. bruger/år",
    "CHANGE_PLAN_CONFIRMATION": "Er du sikker på, at du vil ændre din plan til {{planName}}/{{period}}?",
    "CHANGE_PLAN_SUCCESS_MESSAGE": "Planen er planlagt til at ændre sig på næste faktureringsdato",
    "SCHEDULED_PLAN_MESSAGE": "Dit abonnement ændres til <span class='font-bold'>{{planName}}-planen</span> den {{date}}",
    "SCHEDULED_CHANGES_CANCEL_SUCCESS": "Dine planlagte ændringer er blevet annulleret",
    "CANCEL_SUBSCRIPTION_CHANGES": "Annuller ændringer i abonnementet",
    "CANCEL_SUBSCRIPTION_CHANGES_SUBTITLE": "Gå tilbage til dine nuværende planindstillinger",
    "CANCEL_SUBSCRIPTION_CHANGES_DESCRIPTION": "Vil du annullere ændringen af dit abonnement til {{planName}}-planen?",
    "CANCEL_SUBSCRIPTION_CHANGES_SECONDARY_DESCRIPTION": "Din nuværende plan forbliver aktiv.",
    "CANCEL_SUBSCRIPTION_SUBTITLE": "Denne handling kan ikke fortrydes.",
    "CANCEL_SUBSCRIPTION_CONFIRMATION": "Hvis du annullerer dit abonnement, mister du adgangen og bliver ikke opkrævet i næste faktureringsperiode.",
    "CANCEL_SUBSCRIPTION_CONFIRMATION_END_DATE": "Dit nuværende abonnement forbliver aktivt indtil {{endDate}}.",
    "CANCEL_SUBSCRIPTION_SUCCESS": "Dit abonnement er blevet planlagt til annullering",
    "CANCEL_SUBSCRIPTION_MESSAGE": "Din plan er planlagt til at blive annulleret den {{date}}",
    "REMOVE_CANCELLATION": "Fjern Annullering",
    "REMOVE_CANCELLATION_SUBTITLE": "Dit abonnement forbliver aktivt.",
    "REMOVE_CANCELLATION_DESCRIPTION": "Vil du fjerne annulleringen af dit abonnement?",
    "REMOVE_CANCELLATION_BILLING_DATE": "Dit abonnement forbliver aktivt, og du vil blive opkrævet den {{date}}",
    "REMOVE_CANCELLATION_SUCCESS": "Din planlagte annullering af abonnementet er blevet fjernet",
    "ROLE_UPDATED_SUCCESSFULLY": "Brugerrollen blev opdateret med succes",
    "API_SETTINGS": {
      "TITLE": "API-indstillinger",
      "DESCRIPTION": "Generér API-nøgler og administrer legitimationsoplysninger for at integrere sikkert med eksterne systemer.",
      "EMPTY_TITLE": "Ingen API-nøgler endnu",
      "EMPTY_DESCRIPTION": "Opret din første API-nøgle for at integrere med eksterne tjenester og automatisere dit signeringsflow.",
      "CREATE_API_KEY": "Opret API-nøgle",
      "CREATE_MODAL_SUBTITLE": "Generér en ny API-nøgle til dit arbejdsområde.",
      "EDIT_API_KEY": "Rediger API-nøgle",
      "EDIT_MODAL_SUBTITLE": "Opdater navnet og tilladelserne for din API-nøgle.",
      "KEY_NAME": "Nøglenavn",
      "KEY_NAME_HINT": "Standardnavnet er navnet på dit arbejdsområde",
      "EXPIRATION_DATE": "Udløbsdato",
      "EXPIRATION_DAYS": "{{days}} dage",
      "PERMISSIONS": "Tilladelser",
      "PERMISSION": {
        "CREATE": "Opret",
        "READ": "Læs",
        "UPDATE": "Opdater",
        "DELETE": "Slet"
      },
      "PERMISSION_REQUIRED": "Vælg mindst én tilladelse.",
      "CREATE": "Opret",
      "SAVE": "Gem",
      "DONE": "Færdig",
      "COPY": "Kopiér {{field}}",
      "CREATED_TITLE": "API-nøglen blev oprettet",
      "CREATED_SUBTITLE": "Dine nye legitimationsoplysninger er klar til brug.",
      "ROTATED_TITLE": "API-nøglen blev roteret",
      "ROTATED_SUBTITLE": "Dine nye legitimationsoplysninger er klar til brug.",
      "CLIENT_ID": "Klient-ID",
      "SECRET_KEY": "Hemmelig nøgle",
      "SAVE_SECRET_WARNING": "Gem din hemmelige nøgle nu. Du vil ikke kunne se den igen.",
      "STATUS": {
        "ACTIVE": "Aktiv",
        "DISABLED": "Deaktiveret"
      },
      "CREATED": "Oprettet",
      "LAST_USED": "Senest brugt",
      "NEVER_USED": "Aldrig",
      "DATE_AT_TIME": "{{date}} kl. {{time}}",
      "EXPIRES_ON": "{{date}} ({{days}} dage)",
      "DISABLE": "Deaktiver",
      "ENABLE": "Aktiver",
      "ROTATE": "Roter",
      "MENU": {
        "ROTATE": "Roter API-nøgle",
        "EDIT": "Rediger API-nøgle",
        "DELETE": "Slet nøgle"
      },
      "DISABLED_BANNER": "Denne API-nøgle er i øjeblikket deaktiveret. Aktiver den for at genoprette adgangen.",
      "ROTATE_MODAL": {
        "TITLE": "Roter API-nøgle",
        "SUBTITLE": "Dette vil tilbagekalde din nuværende nøgle.",
        "MESSAGE": "Dette genererer en ny hemmelig nøgle med de samme tilladelser. Den nuværende nøgle tilbagekaldes øjeblikkeligt, og alle integrationer, der bruger den, holder op med at virke.",
        "CALLOUT": "Nøglerotation er permanent. Gem din nye nøgle nu.",
        "CONFIRM": "Roter nøgle"
      },
      "DISABLE_MODAL": {
        "TITLE": "Deaktiver API-nøgle",
        "SUBTITLE": "Denne nøgle holder op med at virke øjeblikkeligt.",
        "MESSAGE": "Alle integrationer, der bruger denne nøgle, mister øjeblikkeligt adgangen til API'et og holder op med at fungere. Du kan når som helst genaktivere nøglen for at genoprette adgangen.",
        "CALLOUT": "Du kan når som helst genaktivere denne nøgle.",
        "CONFIRM": "Deaktiver nøgle"
      },
      "ACTIVATE_MODAL": {
        "TITLE": "Aktiver API-nøgle",
        "SUBTITLE": "Denne nøgle begynder at virke øjeblikkeligt.",
        "MESSAGE": "Alle integrationer, der er konfigureret med denne nøgle, får adgang til API'et igen. Sørg for, at dine tjenester er klar til at håndtere forespørgsler.",
        "CALLOUT": "Når nøglen er aktiveret, er den straks i drift.",
        "CONFIRM": "Aktiver nøgle"
      },
      "DELETE_MODAL": {
        "TITLE": "Slet API-nøgle",
        "SUBTITLE": "Denne handling kan ikke fortrydes.",
        "MESSAGE": "Den valgte API-nøgle og alle tilknyttede tilladelser fjernes permanent. Alle aktive integrationer eller tjenester, der afhænger af denne nøgle, fejler øjeblikkeligt.",
        "CALLOUT": "Dette kan ikke fortrydes. Sørg for, at ingen tjenester afhænger af denne nøgle.",
        "CONFIRM": "Slet nøgle"
      },
      "UPDATED_SUCCESSFULLY": "API-nøglen blev opdateret",
      "DISABLED_SUCCESSFULLY": "API-nøglen blev deaktiveret",
      "ENABLED_SUCCESSFULLY": "API-nøglen blev aktiveret",
      "DELETED_SUCCESSFULLY": "API-nøglen blev slettet",
      "SCOPES": "Omfang",
      "SCOPE": {
        "ORDERS_READ": "Læs",
        "ORDERS_CREATE": "Opret",
        "ORDERS_CANCEL": "Slet",
        "WEBHOOKS_MANAGE": "Webhooks-tilladelse"
      },
      "EXPIRY": {
        "ONE_MONTH": "30 dage",
        "THREE_MONTHS": "90 dage",
        "SIX_MONTHS": "180 dage",
        "ONE_YEAR": "1 år"
      }
    }
  },
  "TRANSACTION_HISTORY": {
    "PAYMENT_ID": "Transaktions-ID",
    "TRANSACTION_DATE": "Betalingsdato",
    "DOWNLOAD_INVOICE": "Download",
    "NO_HISTORY": "Ingen faktureringshistorik endnu",
    "NO_HISTORY_DESCRIPTION": "Dine faktureringstransaktioner og fakturaer vises her, når du har foretaget din første betaling."
  },
  "DATE_RANGE": {
    "ALL_TIME": "Al tid",
    "LAST_YEAR": "Sidste år",
    "LAST_MONTH": "Sidste måned",
    "LAST_7_DAYS": "Seneste 7 dage",
    "CURRENT_MONTH": "Nuværende måned"
  },
  "FILE": {
    "DROP_FILE": "Slip filer eller",
    "UPLOAD_DOCUMENTS": "Upload dokumenter her",
    "BROWSE": "gennemse",
    "SUPPORTED_FORMAT": "Understøttede formater: JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word, PPT",
    "SUPPORTED_FORMAT_PDF": "Understøttede formater: PDF",
    "TITLE": "Filnavn",
    "TYPE": "Type",
    "ATTACHMENT": "VEDHÆFTNING",
    "TO_SIGN": "Til underskrift",
    "DUPLICATE_ERROR_MESSAGE": "Filen findes allerede",
    "DOCUMENTS": "Dokumenter",
    "NO_DOCUMENTS": "Ingen dokumenter tilføjet endnu",
    "RENAME_TITLE": "Omdøb duplikeret fil",
    "RENAME_SUBTITLE": "Vælg et nyt navn til hver duplikeret fil",
    "SIZE_KB": "KB",
    "SIZE_MB": "MB"
  },
  "VALIDATION_MESSAGES": {
    "ONE_RECIPIENT": "Tilføj mindst én modtager",
    "ONE_FILE": "Tilføj mindst én fil",
    "IS_REQUIRED": "er påkrævet",
    "CONTRACT_CREATED": "Kontraktordre oprettet",
    "CONTRACT_SIGNED": "Kontraktordre underskrevet",
    "REQUIRED": "Dette felt er påkrævet",
    "PHONE_INVALID": "Indtast et gyldigt telefonnummer",
    "NAME_INVALID": "Navn er påkrævet",
    "EMAIL_INVALID": "Indtast en gyldig email",
    "EMAIL_REQUIRED": "Email er påkrævet",
    "EMAIL_EXISTS": "Email findes allerede",
    "MINIMUM_AGE": "Din alder er {{age}} år, du skal være mindst {{minAge}} år gammel",
    "MAXIMUM_AGE": "Din alder er {{age}} år, du skal være højst {{maxAge}} år gammel",
    "MINIMUM_LENGTH": "Det skal være mindst {{length}} tegn",
    "MAXIMUM_LENGTH": "Det skal være højst {{length}} tegn",
    "PASSWORD_MISMATCH": "Din adgangskode matcher ikke",
    "LENGTH_INPUT": "Den indtastede værdi er {{length}} tegn",
    "NOT_EMPTY": "Dette felt kan ikke være tomt",
    "DUPLICATE_EMAIL": "Duplikerede e-mails er ikke tilladt",
    "DOCUMENT_REQUIRED": "Mindst ét dokument skal leveres",
    "INVALID_PHONE_NUMBER": "Ugyldigt telefonnummer",
    "MISSING_DATA": "Udfyld venligst de påkrævede felter"
  },
  "ORDER_ACTIVITY": {
    "ORDER_ACTIVITY": "Ordre aktivitet",
    "TIME": "Tid",
    "RECIPIENT": "Modtager",
    "ACTION": "Handling",
    "ACTIVITY": "Aktivitet",
    "STATUS": "Status",
    "DATA_LOADING": "Data indlæses",
    "NO_DATA_FOUNDED": "Ingen data fundet"
  },
  "ERRORS": {
    "NOT_FOUND": "Siden blev ikke fundet",
    "FORBIDDEN": "Du har ikke tilladelse til at tilgå denne side",
    "FILE_NOT_SUPPORTED": "Filtypen understøttes ikke",
    "SERVER_ERROR": "Noget gik galt. Prøv igen.",
    "UNKNOWN_ERROR": "En ukendt fejl opstod, kontakt venligst supporten."
  },
  "LOGIN": {
    "MESSAGE": "Log ind på DSS",
    "LOGIN-ERROR": "Login fejl. Prøv igen",
    "UNAUTHORIZED": "Ikke autoriseret til at logge ind med denne e-mail",
    "WELCOME_BACK": "Velkommen tilbage!",
    "WELCOME": "Velkommen",
    "LOGIN_AGAIN": "Log venligst ind for at få adgang til systemet",
    "TRY_AGAIN": "Prøv venligst igen"
  },
  "CREATE_CLIENT": {
    "DSS": "DSS",
    "HEADING": "Kontraktsamarbejde for alle faser af livscyklussen",
    "NOTE": "*Fortæl os hvem din nuværende arbejdsgiver er"
  },
  "CREATE_ORGANIZATION": {
    "HEADING": "Lad os oprette din organisation",
    "SUBHEADING": "Organisationen er beholderen for dine ordrer eller dokumenter.",
    "ORGANIZATION_NAME": "Organisationsnavn",
    "FORM_EYEBROW": "ORGANISATIONSOPSÆTNING",
    "FORM_HEADING": "Giv din organisation et navn",
    "FORM_SUBHEADING": "Her vil dit teams dokumenter ligge. Du inviterer teammedlemmer i næste trin.",
    "ORGANIZATION_NAME_PLACEHOLDER": "f.eks. JunoSign Inc.",
    "FIELD_HINT": "Dette navn vises på alle dokumenter og invitationer sendt fra din organisation.",
    "NAME_MAX_LENGTH_ERROR": "Organisationsnavnet må ikke overstige 50 tegn.",
    "CREATE_ERROR": "Der opstod en fejl under oprettelsen af din organisation. Prøv venligst igen.",
    "SUBMIT_BUTTON": "Opret organisation",
    "BACK_LINK": "Tilbage",
    "STEP_BADGE": "Trin 3 af 4 — Organisationsopsætning",
    "HERO_HEADLINE_1": "Ét sted til",
    "HERO_HEADLINE_2": "hver ",
    "HERO_HEADLINE_ITALIC": "underskrift.",
    "HERO_TEXT_1": "Ét hjem for alle dokumenter, underskrivere og revisionsspor, som dit team opretter. Sæt det op én gang.",
    "BENEFIT_1_TITLE": "Juridisk gyldige i MENA og Europa",
    "BENEFIT_1_DESC": "eIDAS QES, SOC 2 II, SSL — dine underskrifter holder, hvor det betyder noget.",
    "BENEFIT_2_TITLE": "Send dit første dokument på 90 sekunder",
    "BENEFIT_2_DESC": "Træk, slip, send. Genanvendelige skabeloner til ugentlige kontrakter.",
    "BENEFIT_3_TITLE": "Bygget til teams, prissat retfærdigt",
    "BENEFIT_3_DESC": "Roller, revisionslogfiler, SSO. Per-sæde fakturering — ingen overraskende tillæg.",
    "STAT_SIGN_TIME_LABEL": "Gns. underskrivningstid",
    "STAT_UPTIME_LABEL": "Driftstid SLA",
    "STAT_TEAMS_LABEL": "Aktive teams"
  },
  "INVITE_MEMBERS": {
    "CALLABORATE_WITH_YOUR_TEAM": "Samarbejde med dit team",
    "INVITE_YOUR_TEAMMATES": "Inviter dine holdkammerater",
    "ADD_ANOTHER": "Tilføj endnu en",
    "BUTTON_FINISH": "Afslut",
    "BUTTON_SKIP": "Spring over for nu",
    "BUTTON_BACK": "Tilbage",
    "CHARGED_PER_INVITE": "Hvert teammedlems abonnementsgebyr opkræves separat, efter at de har accepteret invitationen og logget ind for første gang.",
    "FORM_EYEBROW": "VALGFRIT - DU KAN SPRINGE OVER",
    "FORM_SUBHEADING": "Tilføj teammedlemmer til din organisation. Hver af dem får en e-mailinvitation til at deltage.",
    "EMAIL_PLACEHOLDER": "navn@virksomhed.dk",
    "BILLING_NOTE": "Hvert teammedlem bruger ét sæde, som faktureres månedligt. Du kan tilføje eller fjerne sæder når som helst i Indstillinger.",
    "SEND_INVITES": "Send invitationer",
    "STEP_BADGE": "Trin 4 af 4 — Invitér team",
    "HERO_HEADLINE_1": "Underskrifter fungerer",
    "HERO_HEADLINE_2": "bedre",
    "HERO_HEADLINE_3": "som et team.",
    "HERO_TEXT_1": "Tilføj teammedlemmer via e-mail, og angiv deres rolle. De kan forberede, sende og spore dokumenter, så snart de accepterer invitationen.",
    "BENEFIT_1_TITLE": "Juridisk gyldige i MENA og Europa",
    "BENEFIT_1_DESC": "Underskrifter er juridisk gyldige efter Egyptens lov nr. 15 af 2004, reguleret af ITIDA, og i hele Europa i henhold til eIDAS.",
    "BENEFIT_2_TITLE": "Send dit første dokument på 90 sekunder",
    "BENEFIT_2_DESC": "Træk, slip, send. Genanvendelige skabeloner til ugentlige kontrakter.",
    "BENEFIT_3_TITLE": "Bygget til teams, prissat retfærdigt",
    "BENEFIT_3_DESC": "Roller, revisionslogfiler, SSO. Per-sæde fakturering — ingen overraskende tillæg."
  },
  "PAYMENT": {
    "YEARLY_PLAN": "Årligt abonnement",
    "MONTHLY_PLAN": "Månedligt abonnement",
    "SUBSCRIPTION_MODAL_TITLE": "Vælg den rigtige plan for din virksomhed",
    "SUBSCRIPTION_MODAL_DESCRIPTION": "Hos JUnoSign fokuserer vi på markeder, hvor teknologi, innovation og kapital kan frigøre langsigtet værdi og drive økonomisk vækst.",
    "MONTHLY": "Månedligt",
    "YEARLY": "Årligt",
    "CHOOSE_PLAN": "Vælg abonnement",
    "TERMS_AND_CONDITIONS": "Vilkår og betingelser",
    "LIMITED_LINKS": "Alle begrænsede links",
    "ANALYTICS_PLATFORM": "Egen analyseplatform",
    "CHAT_SUPPORT": "Chat support",
    "OPTIMIZE_HASHTAGS": "Optimer hashtags",
    "UNLIMITED_USERS": "Ubegrænsede brugere"
  },
  "FORMS": {
    "FORM_INFORMATION": "Formularoplysninger",
    "TRUCK": "Lastbil",
    "LICENSE": "Licens",
    "TRADER_NAME": "Händlernavn",
    "TRADER_EMAIL": "Händler-e-mail",
    "TRADER_PHONE": "Händlertelefon",
    "FORM_DETAILS": "Formulardetaljer",
    "ITEMS": "Varer",
    "QUANTITY": "Antal",
    "PRICE": "Pris",
    "TOTAL": "Total",
    "ITEM_NAME": "Varenavn",
    "APPLES": "Æbler",
    "BANANAS": "Bananer",
    "WATERMELONS": "Vandmeloner",
    "ORANGES": "Appelsiner",
    "GRAPES": "Druer",
    "SUBMIT": "Indsend",
    "ITEM_REQUIRED": "Vare er påkrævet",
    "FORMS": "Formularer",
    "CREATE_FORM": "Opret en formular",
    "FORM_ID": "Formular-ID",
    "FORM_NAME": "Formularnavn",
    "CREATED_AT": "Oprettet den",
    "LINK": "Link",
    "DELETE": "Slet",
    "LATEST_SUBMISSION": "Seneste indsendelse",
    "FORM_CREATED_SUCCESSFULLY": "Formular oprettet med succes",
    "FAILED_TO_CREATE_FORM": "Kunne ikke oprette formularen",
    "SETTINGS": {
      "FORM_SETTINGS": "Formularindstillinger",
      "SIGNER_SETTINGS": "Underskriverindstillinger",
      "NOTIFICATIONS": "Notifikationer",
      "BASIC_INFORMATION": {
        "TITLE": "Grundlæggende information",
        "FORM_NAME": "Formularnavn",
        "LANGUAGE": "Sprog",
        "REPLY_TO_NAME": "Svar til navn",
        "REPLY_TO_EMAIL": "Svar til e-mail"
      }
    }
  },
  "ORGANIZATIONS": {
    "SWITCH_ORGANIZATION": "Skift organisation",
    "SELECT_WORKSPACE": "Vælg det arbejdsområde, der skal skiftes til",
    "SWITCH": "Skift",
    "CURRENT": "Nuværende",
    "NEW_ORGANIZATION": "Ny organisation?",
    "CREATE_NOW": "Opret nu",
    "MEMBERS": "medlemmer"
  },
  "TERMS_AND_CONDITIONS": {
    "FIRST": "Accept af vilkår",
    "FIRSTDESCRIPTION": " Ved at bruge DSS accepterer du at være bundet af disse vilkår og betingelser. Hvis du ikke accepterer disse vilkår og betingelser, skal du ikke bruge DSS. ",
    "SECOND": "Ændring af vilkår og betingelser",
    "SECONDDESCRIPTION": " DSS forbeholder sig retten til at ændre, rette eller opdatere disse vilkår og betingelser efter eget skøn. Eventuelle ændringer af vilkårene træder i kraft straks efter offentliggørelse af den reviderede version på DSS-webstedet. Det er dit ansvar regelmæssigt at gennemgå vilkårene for at holde dig informeret om eventuelle ændringer. Fortsat brug af DSS efter offentliggørelse af ændringer udgør din accept af de opdaterede vilkår og betingelser. Hvis du ikke accepterer ændringerne, bedes du undlade at bruge DSS og kontakte os på [Dine kontaktoplysninger] med eventuelle bekymringer. ",
    "THIRD": "Tjenester DSS leverer",
    "THIRDDESCRIPTION": "En elektronisk signaturløsning, der giver brugerne mulighed for at underskrive og sende dokumenter elektronisk. DSS er en cloud-baseret tjeneste, der er tilgængelig fra enhver internetforbundet enhed.",
    "FOURTH": "Brugerkonti For at bruge DSS",
    "FOURTHDESCRIPTION": "skal du oprette en brugerkonto. Når du opretter en konto, bliver du bedt om at angive visse oplysninger, herunder dit navn, e-mailadresse og adgangskode. Du er ansvarlig for at opretholde fortroligheden af dine kontooplysninger.",
    "FIFTH": "Brug af tjenester",
    "FIFTHDESCRIPTION": "Du må bruge DSS til at underskrive og sende dokumenter til personlige eller forretningsmæssige formål. Du må ikke bruge DSS til at underskrive eller sende dokumenter, der er ulovlige, skadelige eller ærekrænkende.",
    "SIXTH": "Intellektuel ejendomsret DSS og alt dets indhold",
    "SIXTHDESCRIPTION": " Herunder, men ikke begrænset til, software, tekst, billeder og grafik, tilhører DSS. Du må ikke kopiere, ændre, distribuere eller sælge nogen del af DSS uden vores skriftlige tilladelse.",
    "SEVENTH": " databeskyttelse",
    "SEVENTHDESCRIPTION": "Hos DSS er beskyttelse af dine data vores største forpligtelse. Vi overholder strenge privatlivsstandarder for at sikre fortroligheden og sikkerheden af dine personlige oplysninger. Vi bekræfter utvetydigt, at vi under ingen omstændigheder vil sælge, lease eller på anden måde videregive dine personlige oplysninger til tredjeparter uden at indhente dit udtrykkelige og informerede samtykke. Vores dedikation til dit privatliv omfatter brug af avancerede krypteringsprotokoller, implementering af sikker datalagringspraksis og kontinuerlig overvågning og forbedring af vores sikkerhedsforanstaltninger for at mindske potentielle risici. Vi anerkender følsomheden af de oplysninger, du betror os, og er urokkelige i vores løfte om at behandle dem med den største omhu og omhu. Skulle der være foreslåede ændringer i vores databeskyttelsespraksis, underretter vi dig straks og indhenter dit samtykke, hvor det kræves i henhold til gældende love og regler. For en omfattende forståelse af vores databeskyttelsespolitikker henvises til vores privatlivspolitik, som detaljeret beskriver, hvordan vi indsamler, behandler og beskytter dine personlige oplysninger.",
    "EIGHTH": " Ansvarsbegrænsning",
    "EIGHTHDESCRIPTION": "DSS er ikke ansvarlig for skader, herunder, men ikke begrænset til, tabt fortjeneste,  datalab eller driftsforstyrrelser som følge af brug eller manglende evne til at bruge DSS. Brugere anerkender, at DSS leveres som det er, og selvom der gøres en ihærdig indsats for at sikre dets funktionalitet og pålidelighed, kan uforudsete omstændigheder eller tekniske problemer opstå. DSS, dets tilknyttede selskaber eller dets licensgivere er under ingen omstændigheder ansvarlige for direkte, indirekte, tilfældige, særlige eller følgeskader, uanset om de er baseret på garanti, kontrakt, skadevoldende handling eller anden juridisk teori, der opstår som følge af brugen eller ydeevnen af DSS. Brugere opfordres til regelmæssigt at sikkerhedskopiere kritiske data og vurdere kompatibiliteten af DSS med deres specifikke krav. DSS fraskriver sig garantier eller repræsentationer vedrørende nøjagtigheden, fuldstændigheden eller pålideligheden af softwaren. Ved at bruge DSS accepterer og anerkender brugerne denne ansvarsbegrænsning, og det anbefales at gennemgå disse vilkår med jævne mellemrum for bevidsthed og forståelse",
    "NINTH": " Gældende lov",
    "NINTHDESCRIPTION": " Disse vilkår og betingelser er underlagt og fortolkes i overensstemmelse med gældende lovgivning i den jurisdiktion, hvor brugeren er placeret, eller, hvis ikke angivet, i overensstemmelse med de love, som parterne har valgt til at regulere brugen af denne e-signaturløsning kaldet DSS. Parterne accepterer hermed at underkaste sig den eksklusive jurisdiktion for de kompetente domstole i den relevante jurisdiktion til løsning af eventuelle tvister, der opstår i henhold til eller i forbindelse med disse vilkår og betingelser.",
    "TENTH": " Hele aftalen",
    "TENTHDESCRIPTION": "Disse vilkår og betingelser udgør hele aftalen mellem dig og DSS og erstatter alle tidligere aftaler og forståelser mellem parterne.",
    "ELEVENTH": " Abonnementsbetalinger og refusioner",
    "ELEVENTHDESCRIPTION": "Når du foretager en abonnementsbetaling for DSS, anerkender og accepterer du, at abonnementsgebyrerne ikke refunderes. Der ydes ingen refusion, før abonnementsperioden udløber. Det er dit ansvar at evaluere og sikre kompatibiliteten af DSS med dine krav, før du forpligter dig til et abonnement. Hvis du har spørgsmål eller bekymringer vedrørende abonnementsvilkårene, bedes du kontakte os på [Dine kontaktoplysninger], før du foretager en betaling. Uadskillelighed Hvis en bestemmelse i disse vilkår og betingelser anses for at være ugyldig, vil en sådan bestemmelse blive fjernet fra disse vilkår og betingelser, og de resterende bestemmelser forbliver i fuld kraft og effekt.",
    "TWELFTH": " Ingen afkald på nogen bestemmelse",
    "TWELFTHDESCRIPTION": " i disse vilkår og betingelser er gyldige, medmindre det er dokumenteret skriftligt og behørigt underskrevet af begge parter for at blive betragtet som gyldig.",
    "THIRTEEN": " Kontaktoplysninger",
    "THIRTEENDESCRIPTION": "Hvis du har spørgsmål om disse vilkår og betingelser, bedes du kontakte os på [Dine kontaktoplysninger].",
    "AGREE_TERMS_AND_CONDITIONS": "Ved at markere bekræfter du, at du har læst, forstået og accepterer DSS' vilkår og betingelser.",
    "PROCEED": "Bekræft og fortsæt"
  },
  "FORM_BUILDER": {
    "NAME": "Formularbygger",
    "NEW_FORM": "Ny formular",
    "SIGNER": "Signer",
    "TEXTAREA": "Text area",
    "FORM_ELEMENTS": "Formularelementer",
    "PRIMARY_SIGNER": "Primær underskriver",
    "GROUP_TITLE": "Gruppetitel"
  },
  "facebook": "Fortsæt med Facebook",
  "NO-RESULTS": "Ingen resultater fundet",
  "NO-RESULTS-DESCRIPTION": "Ingen resultater matcher din søgning. Prøv at justere dine søgeord eller fjern eventuelle aktive filtre.",
  "NO-ORDERS": "Ingen underskriftsordrer endnu",
  "NO-ORDERS-DESCRIPTION": "Opret din første underskriftsordre for at komme i gang. Del dokumenter med modtagere og følg deres underskriftsfremskridt.",
  "CONTRACT_SIGNED": "Kontraktordre underskrevet med succes",
  "CONTRACT_REVIEWED": "Kontraktordre gennemgået med succes",
  "SERVICE_IN_MAINTENANCE": "Service under vedligeholdelse",
  "SIGNING_HEADER": {
    "SIGNATURE_REQUESTED": "Underskrift anmodet"
  },
  "SIGNING_PARTICIPANT": {
    "DELETE_RECIPIENT_TITLE": "Slet modtager",
    "DELETE_RECEIVER_TITLE": "Slet kopimodtager",
    "REMOVE_RECIPIENT": "Slet modtager",
    "REMOVE_RECEIVER": "Slet kopimodtager",
    "DELETE_RECIPIENT_DESCRIPTION": "Dette fjerner modtageren permanent fra underskriftsordren. Alle felter tildelt til dem bliver ikke-tildelte.",
    "DELETE_RECEIVER_DESCRIPTION": "Dette fjerner kopimodtageren permanent fra underskriftsordren. Alle felter tildelt til dem bliver ikke-tildelte.",
    "SEND_REMINDER_TITLE": "Send en påmindelse",
    "SEND_REMINDER_SUBTITLE": "Vælg modtagere, der skal have besked",
    "SELECTED_COUNT": "{{count}} valgt",
    "DELETE_SUBTITLE": "Denne handling kan ikke fortrydes."
  },
  "DOCUMENT_PREVIEW": {
    "DECLINE_ORDER_TITLE": "Afvis underskriftsordre",
    "DECLINE_ORDER_SUBTITLE": "Denne handling kan ikke fortrydes.",
    "DECLINE_ORDER_CONFIRM": "Ja, jeg er sikker",
    "DECLINE_MODAL_TITLE": "Afvis denne ordre",
    "DECLINE_MODAL_SUBTITLE": "Denne handling kan ikke fortrydes",
    "DECLINE_MODAL_CANCEL": "Annuller",
    "DECLINE_MODAL_CONFIRM": "Afvis ordre",
    "DECLINE_CONFIRMATION": "Er du sikker på, at du vil afvise denne underskriftsordre? Dette vil underrette alle underskrivere og permanent annullere anmodningen.",
    "DECLINE": "Afvis ordre",
    "APPROVE": "Godkend/Underskriv Ordre",
    "REVIEWED": "Markér ordre som gennemgået",
    "REFRESH": "Opdater side",
    "SOMETHING_WENT_WRONG": "Noget gik galt. Prøv venligst igen senere!",
    "NOT_FOUND": "Kunne ikke hente dit dokument, kontakt venligst support",
    "SUPPORT": "Din webbrowser understøtter ikke filrendering",
    "DOWNLOAD": "Download fil",
    "CONFIRMATION_MESSAGE": "Jeg bekræfter, at jeg har læst og forstået alle dokumenterne.",
    "MODAL_CONFIRMATION_MESSAGE": "Bekræft venligst, at du har læst og forstået alle de leverede dokumenter",
    "USER_AGREEMENT": "Brugeraftale",
    "AGREE_SIGN": "Accepter & Underskriv",
    "INVALID_EMAIL": "Dette dokument er tildelt en anden e-mailadresse",
    "WRONG_EMAIL_EXPLANATION": "Du er logget ind med en e-mailadresse, der ikke matcher modtageren, som blev inviteret til at underskrive dette dokument.",
    "HIDE_MY_EMAIL_NOT_ALLOWED": "Skjult e-mail registreret - Apples skjulte e-mail er ikke accepteret. Klik på <a href=\"https://support.apple.com/en-eg/guide/icloud/mm3adb030cbf/icloud\" target=\"_blank\" class=\"underline\">mere info</a>",
    "STEP_VERIFY": "Bekræft",
    "STEP_REVIEW": "Gennemse",
    "STEP_SIGN": "Underskriv",
    "STEP_DONE": "Færdig",
    "REVIEW_TITLE": "Gennemse dine dokumenter",
    "REVIEW_SUBTITLE": "Læs alle dokumenter omhyggeligt, før du fortsætter med at underskrive. Du skal bekræfte, at du har gennemset dem.",
    "REQUEST_DETAILS_LABEL": "Anmodningsdetaljer",
    "YOU": "dig",
    "SIGNER_LABEL": "Underskriver",
    "SENDER_LABEL": "Afsender",
    "ORGANIZATION_LABEL": "Organisation",
    "EXPIRES_LABEL": "Udløber",
    "DOCUMENTS_LABEL": "Dokumenter til underskrivelse",
    "PREVIEW_BUTTON": "Forhåndsvisning",
    "INFO_NOTE": "Gennemgå venligst alle vedhæftede dokumenter i deres helhed. Ved at underskrive bekræfter du, at du har læst, forstået og accepteret alle betingelser heri.",
    "CONTINUE_TO_SIGN": "Fortsæt til underskrivelse",
    "SCROLL_TO_UNLOCK": "Forhåndsvis alle dokumenter for at fortsætte",
    "PAGE_COUNT": "{{count}} sider",
    "LOADING_DOCUMENT": "Indlæser dokument..."
  },
  "SIGN_IN": {
    "MESSAGE": "Log ind på DSS",
    "HEADING": "Kontraktsamarbejde for hver fase af livscyklussen",
    "SOMETHING_WENT_WRONG": "Noget gik galt. Prøv venligst igen senere!",
    "LOGOUT_AND_RETRY": "Prøv igen",
    "SIGN_HEADING": "Underskriv din ordre",
    "SIGN_SUBHEADING": "Bekræft din identitet for at gennemgå og underskrive ordren, der er sendt til dig.",
    "CONTINUE_WITH": "Fortsæt med {{provider}}",
    "METHOD_GOOGLE_DESCRIPTION": "Log ind med din Google-konto",
    "METHOD_APPLE_DESCRIPTION": "Log ind med dit Apple-id",
    "METHOD_LINKEDIN_DESCRIPTION": "Log ind med din LinkedIn-konto",
    "METHOD_DOODLE_DESCRIPTION": "Modtag en engangskode via e-mail",
    "METHOD_TYPED_DESCRIPTION": "Skriv dit navn. Vælg en stil."
  },
  "ORDER_RECEIPT": {
    "ORDER_DECLINED": "Ordre afvist",
    "ORDER_DECLINED_SUCCESSFULLY": "Du har afvist ordren. Du kan lukke dette vindue",
    "ORDER_DECLINED_FAILED": "Det mislykkedes at afvise ordren",
    "SIGNED_SUCCESSFULLY": "Ordre underskrevet med succes",
    "REVIEWED_SUCCESSFULLY": "Ordre gennemgået med succes",
    "SIGNER_NAME": "Underskrivers navn",
    "REVIEWER_NAME": "Gennemgangers navn",
    "ORDER_ID": "Ordre ID #",
    "SIGNED_BY": "Underskrevet af",
    "REVIEWED_BY": "Gennemgået af",
    "SIGNED_ON": "Underskrevet den",
    "REVIEWED_ON": "Gennemgået den",
    "HELP": "Vi er her for at hjælpe! For support eller spørgsmål, kontakt os på",
    "SIGNATURE_REQUESTED": "Underskrift anmodet",
    "SIGNING_REJECTED": "Underskrift afvist",
    "ORDER_SIGNED": "Ordre underskrevet!",
    "ORDER_REVIEWED": "Ordre gennemgået!",
    "ORDER_REJECTED": "Ordre afvist!",
    "ORDER_SIGNED_SUBTITLE": "Din underskrift er registreret og er juridisk bindende.",
    "ORDER_REVIEWED_SUBTITLE": "Din gennemgang er registreret og er juridisk bindende.",
    "ORDER_DECLINED_SUBTITLE": "Du har afvist denne underskriftsanmodning.",
    "ORDER_DECLINED_BY_RECIPIENT_SUBTITLE": "Denne ordre blev afvist af en af modtagerne.",
    "CARD_TITLE_SIGNED": "Ordre underskrevet",
    "CARD_TITLE_REVIEWED": "Ordre gennemgået",
    "CARD_TITLE_REJECTED": "Ordre afvist",
    "STATUS_SIGNED": "Underskrevet",
    "STATUS_REVIEWED": "Gennemgået",
    "STATUS_REJECTED": "Afvist",
    "STATUS_PENDING": "Afventer",
    "REJECTED_ON": "Afvist den",
    "ALL_RECIPIENT_STATUS": "Alle modtageres status",
    "YOU": "Dig",
    "EMAIL_PENDING_NOTE": "Du vil modtage en e-mail med den underskrevne kopi, når alle afventende modtagere har gennemført.",
    "ORDER_CANCELLED": "Ordre annulleret!",
    "ORDER_CANCELLED_SUBTITLE": "Denne ordre er blevet annulleret af afsenderen.",
    "ORDER_CANCELLED_BADGE": "Ordre annulleret",
    "CANCELLED_ON": "Annulleret den",
    "ORDER_EXPIRED": "Ordre udløbet!",
    "ORDER_EXPIRED_SUBTITLE": "Denne ordre er udløbet og accepterer ikke længere underskrifter.",
    "ORDER_EXPIRED_BADGE": "Ordre udløbet",
    "EXPIRED_ON": "Udløbet den",
    "ORDER_PENDING": "Underskrift afventer",
    "ORDER_PENDING_SUBTITLE": "Denne ordre afventer din handling.",
    "REQUESTED_ON": "Anmodet den"
  },
  "404": {
    "MESSAGE": "Åh nej! Siden forsvandt i det digitale ukendte",
    "DESCRIPTION": "Siden, du leder efter, er muligvis blevet fjernet, har fået nyt navn eller er midlertidigt utilgængelig."
  },
  "ORDER_NOT_FOUND": {
    "MESSAGE": "Ordre Ikke Fundet: Det digitale spor fører til en tom kurv",
    "DESCRIPTION": "Den ordre, du anmodede om, eksisterer ikke. Den kan være blevet slettet eller udløbet. Kontrollér ordreoplysningerne og prøv igen"
  },
  "DRAW_SIGNATURE": {
    "MESSAGE": "Tegn din underskrift nedenfor",
    "CLEAR": "Ryd",
    "NEED_DRAW": "Du skal tegne en underskrift",
    "SIGN_DOCUMENT": "Underskriv dokument",
    "TITLE": "Tegn din underskrift",
    "SUBTITLE": "Skriv under i feltet nedenfor med din mus eller finger. Dette vil blive anvendt på alle dokumenter i denne anmodning.",
    "CANVAS_LABEL": "Skriv under her",
    "CANVAS_PLACEHOLDER": "Skriv under med finger eller mus",
    "HINT": "Brug mus eller berøring til at tegne",
    "APPLY_SUBMIT": "Anvend underskrift og indsend",
    "BACK": "Tilbage",
    "REJECT_ORDER": "Afvis ordre"
  },
  "TYPE_SIGNATURE": {
    "BACK": "Tilbage",
    "TITLE": "Skriv din signatur",
    "SUBTITLE": "Skriv dit juridiske navn. JunoSign formaterer det automatisk i din foretrukne professionelle signaturstil.",
    "LANGUAGE_LABEL": "Signatursprog",
    "LANGUAGE_HINT": "Vælg dit foretrukne signatursprog.",
    "SCRIPT_LATIN": "Latin",
    "SCRIPT_ARABIC": "Arabisk",
    "PREVIEW_LABEL": "Forhåndsvisning af signatur",
    "PREVIEW_HINT": "Se, hvordan din professionelle signatur ser ud.",
    "STYLE_LABEL": "Signaturstil",
    "STYLE_1": "Stil 1",
    "STYLE_2": "Stil 2",
    "STYLE_3": "Stil 3",
    "STYLE_4": "Stil 4",
    "LEGAL_NAME_LABEL": "Juridisk navn",
    "LEGAL_NAME_PLACEHOLDER": "Indtast dit fulde juridiske navn",
    "PREVIEW_PLACEHOLDER_LATIN": "Din signatur",
    "PREVIEW_PLACEHOLDER_ARABIC": "توقيعك",
    "APPLY_SUBMIT": "Anvend signatur og indsend",
    "REJECT_ORDER": "Afvis ordre",
    "ERRORS": {
      "MAX_LENGTH": "Navnet må højst være 15 tegn",
      "LATIN_ONLY": "Brug kun latinske bogstaver, eller skift signatursproget til arabisk",
      "ARABIC_ONLY": "Brug kun arabiske bogstaver, eller skift signatursproget til latin"
    }
  },
  "CONFIRM_SIGNATURE": {
    "BACK": "Tilbage",
    "TITLE": "Bekræft din underskrift",
    "SUBTITLE": "Gennemgå din verificerede identitet nedenfor. Dette vil blive anvendt på alle dokumenter i denne anmodning.",
    "YOUR_DIGITAL_SIGNATURE": "Din digitale underskrift",
    "INFO_NOTE": "Ved at anvende din underskrift bekræfter du, at du har læst, forstået og accepteret alle vilkår i dokumenterne.",
    "APPLY_SUBMIT": "Anvend underskrift og indsend",
    "SUBMIT_REVIEW": "Markér ordre som gennemgået",
    "REJECT_ORDER": "Afvis ordre",
    "SIGN_FAILED": "Kunne ikke underskrive ordren. Prøv igen."
  },
  "USER_ROLES": {
    "VIEWER": "Observatør",
    "USER": "Bruger",
    "TEAM_LEAD": "Holdleder",
    "ADMIN": "Administrator",
    "OWNER": "Ejer"
  },
  "REMINDER_INTERVAL": {
    "NEVER": "Aldrig",
    "DAILY": "Dagligt",
    "TWICEAWEEK": "To gange om ugen",
    "WEEKLY": "Ugentligt",
    "ADAYBEFOREEXPIRATION": "En dag før udløb"
  },
  "VERIFICATION_METHOD": {
    "EMAIL": "Email",
    "WHATSAPP_AND_EMAIL": "Whatsapp/Email",
    "WHATSAPP": "Whatsapp"
  },
  "FLOATING_DOC_LAYOUT": {
    "DOC_1_TITLE": "Serviceaftale",
    "DOC_1_META": "Ref · 24-A8F",
    "DOC_1_STATUS": "Underskrevet på 47s",
    "DOC_2_TITLE": "Samarbejdsvilkår — Privat virksomhed",
    "DOC_2_META": "Side 2 af 2 · 1 underskriftsfelt",
    "DOC_3_TITLE": "Fortrolighedsaftale — Privat virksomhed",
    "DOC_3_META": "Fortroligt",
    "SIGN_HERE": "Underskriv her",
    "BADGE_TEXT": "Underskrift anmodet"
  },
  "SNACKBAR": {
    "SUCCESS": "Succes",
    "ERROR": "Fejl",
    "INFO": "Information",
    "WARNING": "Advarsel",
    "AND_MORE": "og {{ count }} mere"
  },
  "TABLE": {
    "NO_DATA": "Ingen data at vise",
    "ACTIONS": "Rækkehandlinger",
    "SELECT_PAGE": "Vælg alle rækker på denne side",
    "SELECT_ROW": "Vælg række",
    "EXPAND_ROW": "Udvid række",
    "COLLAPSE_ROW": "Skjul række"
  }
}
